var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-button-container"},_vm._l((_vm.selectionlist),function(item,index){return _c('button',{key:index,staticClass:"l-btn-default l-btn-type-1",class:{
      'disabled': _vm.optionStatus == 1, 
      'default': _vm.optionStatus == 2, 
      'active': _vm.optionStatus == 3 && index == _vm.optionIndex, 
      'correct': _vm.optionStatus == 4 && item.isRight == 1 && index == _vm.optionIndex, 
      'error': _vm.optionStatus == 4 && item.isRight == 0 && index == _vm.optionIndex},attrs:{"type":"button"},on:{"click":function($event){return _vm.onSelect(item, index)}}},[_c('span',{staticClass:"l-btn-text"},[_vm._v(" "+_vm._s(item.name)+" ")]),(item.isRight == 1 
            && _vm.optionStatus == 4 
            && index != _vm.optionIndex)?_c('img',{staticClass:"right-img",attrs:{"src":require("./images/right.png"),"alt":""}}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }